import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { DateFromTo } from '../../models/common';
import { getDateForApi } from '../../utils/date';
import { invitationService } from '@api/services/services';
import { InvitationLogEntryResponse } from '@api/models/invitation/InvitationLogEntryResponse';
import { InvitationLogEntryType } from '@api/models/enums/InvitationLogEntryType';
import { ReferenceDto } from '@api/models/employees/ReferenceDto';

export interface InvitationHistoryListFilter extends ListFilter {
  actionBy?: ReferenceDto;
  timestamp?: DateFromTo;
  type?: InvitationLogEntryType[];
}

export type InvitationHistoryListState = ListType<InvitationLogEntryResponse, InvitationHistoryListFilter>;

const initialState: InvitationHistoryListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    sortBy: 'timestamp',
    sortDesc: true,
  },
};

export const invitationHistoryListSlice = listSlice({
  name: 'invitationHistoryList',
  initialState,
});

export const selectInvitationHistoryList = (state: RootState) => state.invitationHistoryList;
export const invitationHistoryListActions = invitationHistoryListSlice.actions;

export const getInvitationHistoryList = (invitationId: string, cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectInvitationHistoryList(storeState);

  const handleGetData = (size: number) => {
    return invitationService.getInvitationHistory(
      invitationId,
      {
        page: data.query.page,
        size: size,
        sort: getListSort(data),
        actionBy: data.query.actionBy ? [data.query.actionBy.id] : undefined,
        from: getDateForApi(data.query.timestamp?.from),
        to: getDateForApi(data.query.timestamp?.to),
        type: data.query.type,
      },
      { cancelToken: cancelToken },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: invitationHistoryListActions,
    getData: handleGetData,
  });
};
